import React from 'react';
import { AppTheme } from '../types';

interface ConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  message: string;
  theme: AppTheme;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({ 
  isOpen, 
  onConfirm, 
  onCancel, 
  title, 
  message, 
  theme 
}) => {
  if (!isOpen) return null;

  const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1001,
  };

  const modalStyle: React.CSSProperties = {
    backgroundColor: theme.colors.surface,
    borderRadius: '4px',
    padding: '0',
    width: '400px',
    border: `1px solid ${theme.colors.border}`,
    boxShadow: theme.isDark 
      ? '0 4px 12px rgba(0, 0, 0, 0.5)' 
      : '0 4px 12px rgba(0, 0, 0, 0.15)',
  };

  const headerStyle: React.CSSProperties = {
    padding: '12px 16px',
    borderBottom: `1px solid ${theme.colors.border}`,
    backgroundColor: theme.isDark ? '#333333' : '#f0f0f0',
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '14px',
    fontWeight: 'normal',
    color: theme.colors.text,
    margin: 0,
  };

  const contentStyle: React.CSSProperties = {
    padding: '16px',
    color: theme.colors.text,
    fontSize: '12px',
  };

  const buttonGroupStyle: React.CSSProperties = {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    marginTop: '16px',
  };

  const buttonStyle: React.CSSProperties = {
    padding: '6px 12px',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer',
    fontSize: '11px',
    fontFamily: 'inherit',
  };

  const confirmButtonStyle: React.CSSProperties = {
    ...buttonStyle,
    backgroundColor: '#dc3545',
    color: 'white',
  };

  const cancelButtonStyle: React.CSSProperties = {
    ...buttonStyle,
    backgroundColor: theme.colors.secondary,
    color: 'white',
  };

  return (
    <div style={overlayStyle} onClick={onCancel}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <div style={headerStyle}>
          <h3 style={titleStyle}>{title}</h3>
        </div>
        <div style={contentStyle}>
          <p>{message}</p>
          <div style={buttonGroupStyle}>
            <button style={cancelButtonStyle} onClick={onCancel}>
              Отмена
            </button>
            <button style={confirmButtonStyle} onClick={onConfirm}>
              Удалить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};